import React, {Component} from 'react';
import './CustomerOrderTable.css';
import CustomerOrderTableHeader from "../CustomerOrderTableHeader/CustomerOrderTableHeader";

import {FormattedMessage} from "react-intl";
import CustomerOrderTableRow from "../CustomerOrderTableRow/CustomerOrderTableRow";
import CustomerOrderTableBottom from "../CustomerOrderTableBottom/CustomerOrderTableBottom";
import {RESOURCE_BASE_URL, ITEM_COUNT_PER_PAGE} from "../../../../configuration";
import axios from "axios";
import OrderTableRow from "../../Order/ViewAllOrders/OrderTableRow/OrderTableRow";
import AllOrderBottom from "../../Order/ViewAllOrders/AllOrderBottom/AllOrderBottom";
import { Link } from 'react-router-dom';

class CustomerOrderTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            totalItemCount: 0,
            activePage: 1
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getAllOrders = this.getAllOrders.bind(this);
    }

    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;
        // console.log("PAGE DUO ====>", offset);
        this.getAllOrders(offset, ITEM_COUNT_PER_PAGE);
    };

    componentDidMount() {
        this.getAllOrders(0, ITEM_COUNT_PER_PAGE);
    }

    getAllOrders = (offset, limit) => {

        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/orders?offset=' + offset + '&limit=' + limit)
            .then((res) => {
                this.setState({
                    orders: res.data.orders,
                    totalItemCount: res.data.rowCount
                });
                // console.log("CUSTOMER ORDERS DUO ===> ",res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    render() {

        let no = 1 + ((this.state.activePage - 1) * ITEM_COUNT_PER_PAGE);

        return (
            <div className="container">
                <div className="admin-user-address-list-scroll customer-order-height-responsive admin-tables single-customer-orders-resp">
                    <div className="all-order-table-header admin-table-row-content-resp-1">
                        <table border="1" className="table table-bordered customers-table-resp">
                            <CustomerOrderTableHeader/>

                            <tbody>

                        {this.state.orders.length !== 0 ? this.state.orders.map(orders => {
                            return  <CustomerOrderTableRow key={no++} no={no++} orders={orders}/>

                        }) :
                            <tr><td colSpan={6} className="text-center"><FormattedMessage id="app.no-records-found"
                                                                              defaultMessage="ORDER"
                                                                              description=""/></td></tr>
                        }
                            </tbody>
                        </table>
                        < CustomerOrderTableBottom
                            activePage={this.state.activePage}
                            itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                            totalItemsCount={this.state.totalItemCount}
                            handlePageChange={this.handlePageChange}
                        />
                        <div className="pull-right resp-back-btn-opu">
                            <Link to={"/admin/customers/all"} className="">
                                <FormattedMessage id="app.admin-info.back"
                                                  defaultMessage="<< Back"
                                                  description=""/>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>

        )
            ;
    }

}

export default CustomerOrderTable;



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/CustomerOrderTable/CustomerOrderTable.js